export const form144Sections = [
    { value: '1040', label: '1040' },
    { value: '1041', label: '1041' },
    { value: '1042', label: '1042' },
    { value: '1043', label: '1043' },
    { value: '1044', label: '1044' },
    { value: '1045', label: '1045' },
    { value: '1046', label: '1046' },
    { value: '1048', label: '1048' },
    { value: '1049', label: '1049' },
    { value: '1050', label: '1050' },
    { value: '1051', label: '1051' },
    { value: '1052', label: '1052' },
    { value: '1053', label: '1053' },
    { value: '1054', label: '1054' },
    { value: '1055', label: '1055' },
    { value: '1056', label: '1056' },
    { value: '1057', label: '1057' }
];

export const remittanceOptions144 = [
    { value: '16', label: '16 - Dividend income referred to in the section 207(1) [Table: Sl. No.2]' },
    { value: '21', label: '21 - Fees for Technical Services/ Fees for included services where the agreement is made after the 31st March, 1976' },
    { value: '27', label: '27 - Interest income' },
    { value: '28', label: '28 - Investment income' },
    { value: '49', label: '49 - Royalty where the agreement is made after the 31st March, 1976' },
    { value: '66', label: '66 - Long term capital gains referred to in section 214 [Table: Sl. No. 2]' },
    { value: '67', label: '67 - Long term capital gains referred to in section 197(1)' },
    { value: '68', label: '68 - LTCG other than those specifically listed under Schedule II, Sl. No. 14 and Sl. No. 17 [related to section 10(36) of IT ACT-1961]' },
    { value: '69', label: '69 - Long term capital gains referred to in section 198 exceeding one lakh twenty-five thousand rupees' },
    { value: '70', label: '70 - Short term capital gains referred to in section 196' },
    { value: '71', label: '71 - Long Term Capital Gains arising from transfer Transfer of Units reffered to in Section 208' },
    { value: '72', label: '72 - Long-term capital gains arising from the transfer of bonds or Global Depository Receipts referred to in section 209' },
    { value: '73', label: '73 - Dividend income referred to in the in the section 207(1) [Table: Sl. No.1]' },
    { value: '74', label: '74 - Fees for Technical Services/ Fees for included services where the agreement is made after the 29th February, 1964 but before the 1st April, 1976' },
    { value: '75', label: '75 - Royalty where the agreement is made after the 31st March, 1961 but before the 1st April, 1976' },
    { value: '99', label: '99 - Other income' }
];

export const VALID_REMITTANCE_CODES_144 = [
    '16', '21', '27', '28', '49', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '99'
];

export const formatRemittanceCode144 = (val, sectionCode = '') => {
    const raw = String(val || '').trim();
    const sec = String(sectionCode || '').trim();

    if (raw) {
        // Direct match with valid 2-digit code
        const padded = /^\d{1,2}$/.test(raw) ? raw.padStart(2, '0') : '';
        if (padded && VALID_REMITTANCE_CODES_144.includes(padded)) {
            return padded;
        }

        // Prefix match like "27 - Interest income"
        const prefixMatch = raw.match(/^(\d{1,2})\s*-/);
        if (prefixMatch) {
            const prefixCode = prefixMatch[1].padStart(2, '0');
            if (VALID_REMITTANCE_CODES_144.includes(prefixCode)) {
                return prefixCode;
            }
        }

        // Legacy 01-19 code mapping if stored from earlier sessions
        const legacyCode = padded || (prefixMatch ? prefixMatch[1].padStart(2, '0') : '');
        if (legacyCode) {
            const legacyMap = {
                '05': '27',
                '06': '73',
                '07': '16',
                '09': '28',
                '10': '66',
                '11': '69',
                '12': '68',
                '13': '70',
                '14': '70',
                '17': '49',
                '19': '99'
            };
            if (legacyMap[legacyCode]) return legacyMap[legacyCode];
        }

        // Text description match (e.g. from Excel import)
        const lower = raw.toLowerCase();
        if (lower.includes('interest income') || lower === 'interest' || lower.includes('interest payment')) return '27';
        if (lower.includes('dividend')) {
            if (lower.includes('sl. no.1') || lower.includes('sl. no. 1') || lower.includes('sl.no.1')) return '73';
            return '16';
        }
        if (lower.includes('214')) return '66';
        if (lower.includes('197(1)')) return '67';
        if (lower.includes('schedule ii') || lower.includes('10(36)')) return '68';
        if (lower.includes('198')) return '69';
        if (lower.includes('196') || lower.includes('short term capital')) return '70';
        if (lower.includes('208') || lower.includes('transfer of units')) return '71';
        if (lower.includes('209') || lower.includes('global depository') || lower.includes('bonds')) return '72';
        if (lower.includes('investment income')) return '28';
        if (lower.includes('technical services') || lower.includes('included services')) {
            if (lower.includes('1964')) return '74';
            return '21';
        }
        if (lower.includes('royalty')) {
            if (lower.includes('1961')) return '75';
            return '49';
        }
        if (lower.includes('other income') || lower === 'other') return '99';
    }

    // Section-based fallback if empty/unrecognized
    if (['1040', '1041', '1042', '1043', '1044', '1045'].includes(sec)) return '27';
    if (sec === '1046') return '16';
    if (sec === '1052') return '71';
    if (sec === '1054') return '72';
    return '99';
};

export const minorHeadCodes144 = [
    { value: '200', label: '200 - TDS payable by taxpayer' },
    { value: '400', label: '400 - TDS regular assessment (Raised by I. T. Dept.)' },
    { value: '100', label: '100 - Advance Tax' }
];

export const deductorTypes144 = [
    { value: 'A', label: 'Central Government' },
    { value: 'S', label: 'State Government' },
    { value: 'D', label: 'Statutory body (Central Govt.)' },
    { value: 'E', label: 'Statutory body (State Govt.)' },
    { value: 'G', label: 'Autonomous body (Central Govt.)' },
    { value: 'H', label: 'Autonomous body (State Govt.)' },
    { value: 'L', label: 'Local Authority (Central Govt.)' },
    { value: 'N', label: 'Local Authority (State Govt.)' },
    { value: 'K', label: 'Company' },
    { value: 'M', label: 'Branch / Division of Company' },
    { value: 'P', label: 'Association of Person (AOP)' },
    { value: 'T', label: 'Association of Person (Trust)' },
    { value: 'J', label: 'Artificial Juridical Person' },
    { value: 'B', label: 'Body of Individuals' },
    { value: 'Q', label: 'Individual/HUF' },
    { value: 'F', label: 'Firm' }
];

export const deducteeStatus144 = [
    { value: '01', label: '01 - Company' },
    { value: '02', label: '02 - Individual' },
    { value: '03', label: '03 - Hindu undivided family' },
    { value: '04', label: '04 - Association of Persons (AOP) (excluding all companies)' },
    { value: '05', label: '05 - Association of Persons (AOP) (consisting only companies)' },
    { value: '06', label: '06 - Co-operative society' },
    { value: '07', label: '07 - Firm' },
    { value: '08', label: '08 - Body of individuals' },
    { value: '09', label: '09 - Artificial juridical person' },
    { value: '10', label: '10 - Others' }
];

export const reasonCodes144 = [
    { value: '', label: 'None' },
    { value: 'A', label: 'A - Lower/No deduction on account of certificate u/s 395(1) / 395(2)' },
    { value: 'C', label: 'C - Higher rate u/s 397(2) on account of non-furnishing of PAN' },
    { value: 'G', label: 'G - No deduction on interest paid by Offshore Banking Unit u/s 393(8)' },
    { value: 'H', label: 'H - No deduction u/s 393(4) for specified exempt fund' },
    { value: 'I', label: 'I - No deduction u/s 393(4) on capital gains from securities to FII' },
    { value: 'N', label: 'N - No deduction on payment u/s 393(3) [Table: Sl. No. 5.D(a)/(b)]' },
    { value: 'O', label: 'O - Distributed income referred to in section 223' },
    { value: 'Y', label: 'Y - No deduction on payment below threshold limit as per IT Act 2025' },
    { value: 'Z', label: 'Z - No/lower deduction in view of notification issued u/s 400(1)' }
];

export const applicableTdsOptions144 = [
    { value: 'A', label: 'A - TDS rate as per Income Tax Act' },
    { value: 'B', label: 'B - TDS rate as per DTAA' }
];

export const countryOptions144 = [
    { value: '1', label: '1 - AFGHANISTAN' }, { value: '2', label: '2 - AKROTIRI' }, { value: '3', label: '3 - ALBANIA' },
    { value: '4', label: '4 - ALGERIA' }, { value: '5', label: '5 - AMERICAN SAMOA' }, { value: '6', label: '6 - ANDORRA' },
    { value: '7', label: '7 - ANGOLA' }, { value: '8', label: '8 - ANGUILLA' }, { value: '9', label: '9 - ANTARCTICA' },
    { value: '10', label: '10 - ANTIGUA AND BARBUDA' }, { value: '11', label: '11 - ARGENTINA' }, { value: '12', label: '12 - ARMENIA' },
    { value: '13', label: '13 - ARUBA' }, { value: '14', label: '14 - ASHMORE AND CARTIER ISLANDS' }, { value: '15', label: '15 - AUSTRALIA' },
    { value: '16', label: '16 - AUSTRIA' }, { value: '17', label: '17 - AZERBAIJAN' }, { value: '18', label: '18 - BAHRAIN' },
    { value: '19', label: '19 - BAILIWICK OF GUERNSEY' }, { value: '20', label: '20 - BAILIWICK OF JERSEY' },
    { value: '21', label: '21 - BAKER ISLAND' }, { value: '22', label: '22 - BANGLADESH' }, { value: '23', label: '23 - BARBADOS' },
    { value: '24', label: '24 - BELARUS' }, { value: '25', label: '25 - BELGIUM' }, { value: '26', label: '26 - BELIZE' },
    { value: '27', label: '27 - BENIN PORTO' }, { value: '28', label: '28 - BERMUDA' }, { value: '29', label: '29 - BHUTAN' },
    { value: '30', label: '30 - BOLIVIA' }, { value: '31', label: '31 - BOSNIAAND HERZEGOVINA' }, { value: '32', label: '32 - BOTSWANA' },
    { value: '33', label: '33 - BOUVET ISLAND' }, { value: '34', label: '34 - BRAZIL' }, { value: '35', label: '35 - BRITISH INDIAN OCEAN TERRITORY' },
    { value: '36', label: '36 - BRUNEI' }, { value: '37', label: '37 - BULGARIA' }, { value: '38', label: '38 - BURKINA FASO' },
    { value: '39', label: '39 - BURUNDI' }, { value: '40', label: '40 - CAMBODIA' }, { value: '41', label: '41 - CAMEROON' },
    { value: '42', label: '42 - CANADA' }, { value: '43', label: '43 - CAPE VERDE' }, { value: '44', label: '44 - CAYMAN ISLANDS' },
    { value: '45', label: '45 - CENTRAL AFRICAN REPUBLIC' }, { value: '46', label: '46 - CHAD' }, { value: '47', label: '47 - CHILE' },
    { value: '48', label: '48 - CHINA' }, { value: '49', label: '49 - CHRISTMAS ISLAND' }, { value: '50', label: '50 - CLIPPERTON ISLAND' },
    { value: '51', label: '51 - COCOS (KEELING) ISLANDS' }, { value: '52', label: '52 - COLOMBIA' }, { value: '53', label: '53 - COMMONWEALTH OF PUERTO RICO' },
    { value: '54', label: '54 - COMMONWEALTH OF THE NORTHERN MARIANA ISLANDS' }, { value: '55', label: '55 - COMOROS' },
    { value: '56', label: '56 - CONGO,DEMOCRATIC REPUBLIC OF THE' }, { value: '57', label: '57 - CONGO,REPUBLIC OF THE' },
    { value: '58', label: '58 - COOK ISLANDS' }, { value: '59', label: '59 - CORAL SEA ISLANDS' }, { value: '60', label: '60 - CORAL SEA ISLANDS TERRITORY' },
    { value: '61', label: '61 - COSTA RICA' }, { value: '62', label: '62 - COTE D\'IVOIRE' }, { value: '63', label: '63 - CROATIA' },
    { value: '64', label: '64 - CUBA' }, { value: '65', label: '65 - CYPRUS' }, { value: '66', label: '66 - CZECH REPUBLIC' },
    { value: '67', label: '67 - DENMARK' }, { value: '68', label: '68 - DEPARTMENTAL COLLECTIVITY OF MAYOTTE' }, { value: '69', label: '69 - DHEKELIA' },
    { value: '70', label: '70 - DJIBOUTI' }, { value: '71', label: '71 - DOMINICA' }, { value: '72', label: '72 - DOMINICAN REPUBLIC' },
    { value: '73', label: '73 - EAST TIMOR (TIMORLASTE)' }, { value: '74', label: '74 - ECUADOR' }, { value: '75', label: '75 - EGYPT' },
    { value: '76', label: '76 - ELSALVADOR' }, { value: '77', label: '77 - EQUATORIAL GUINEA' }, { value: '78', label: '78 - ERITREA' },
    { value: '79', label: '79 - ESTONIA' }, { value: '80', label: '80 - ETHIOPIA' }, { value: '81', label: '81 - FALKLAND ISLANDS (ISLAS MALVINAS)' },
    { value: '82', label: '82 - FAROE ISLANDS' }, { value: '83', label: '83 - FIJI' }, { value: '84', label: '84 - FINLAND' },
    { value: '85', label: '85 - FRANCE' }, { value: '86', label: '86 - FRENCH GUIANA' }, { value: '87', label: '87 - FRENCH POLYNESIA' },
    { value: '88', label: '88 - FRENCH SOUTHERN ISLANDS' }, { value: '89', label: '89 - GABON' }, { value: '90', label: '90 - GEORGIA' },
    { value: '91', label: '91 - GERMANY' }, { value: '92', label: '92 - GEURNSEY' }, { value: '93', label: '93 - GHANA' },
    { value: '94', label: '94 - GIBRALTAR' }, { value: '95', label: '95 - GREECE' }, { value: '96', label: '96 - GREENLAND' },
    { value: '97', label: '97 - GRENADA' }, { value: '98', label: '98 - GUADELOUPE' }, { value: '100', label: '100 - GUAM' },
    { value: '101', label: '101 - GUATEMALA' }, { value: '102', label: '102 - GUERNSEY' }, { value: '103', label: '103 - GUINEA' },
    { value: '104', label: '104 - GUINEABISSAU' }, { value: '105', label: '105 - GUYANA' }, { value: '106', label: '106 - HAITI' },
    { value: '107', label: '107 - HEARD ISLAND AND MCDONALD ISLANDS' }, { value: '108', label: '108 - HONDURAS' }, { value: '109', label: '109 - HONG KONG' },
    { value: '110', label: '110 - HOWLAND ISLAND' }, { value: '111', label: '111 - HUNGARY' }, { value: '112', label: '112 - ICELAND' },
    { value: '113', label: '113 - INDIA' }, { value: '114', label: '114 - INDONESIA' }, { value: '115', label: '115 - IRAN' },
    { value: '116', label: '116 - IRAQ' }, { value: '117', label: '117 - IRELAND' }, { value: '118', label: '118 - ISLE OF MAN' },
    { value: '119', label: '119 - ISRAEL' }, { value: '120', label: '120 - ITALY' }, { value: '121', label: '121 - JAMAICA' },
    { value: '122', label: '122 - JAN MAYEN' }, { value: '123', label: '123 - JAPAN' }, { value: '124', label: '124 - JARVIS ISLAND' },
    { value: '125', label: '125 - JERSEY' }, { value: '126', label: '126 - JOHNSTON ATOLL' }, { value: '127', label: '127 - JORDAN' },
    { value: '128', label: '128 - KAZAKHSTAN' }, { value: '129', label: '129 - KENYA' }, { value: '130', label: '130 - KINGMAN REEF' },
    { value: '131', label: '131 - KIRIBATI' }, { value: '132', label: '132 - KOREA, NORTH' }, { value: '133', label: '133 - KOREA, SOUTH' },
    { value: '134', label: '134 - KOSOVO' }, { value: '135', label: '135 - KUWAIT' }, { value: '136', label: '136 - KYRGYZSTAN' },
    { value: '137', label: '137 - LAOS' }, { value: '138', label: '138 - LATVIA' }, { value: '139', label: '139 - LEBANON' },
    { value: '140', label: '140 - LESOTHO' }, { value: '141', label: '141 - LIBERIA' }, { value: '142', label: '142 - LIBYA' },
    { value: '143', label: '143 - LIECHTENSTEIN' }, { value: '144', label: '144 - LITHUANIA' }, { value: '145', label: '145 - LUXEMBOURG' },
    { value: '146', label: '146 - MACAU' }, { value: '147', label: '147 - MACEDONIA' }, { value: '148', label: '148 - MADAGASCAR' },
    { value: '149', label: '149 - MALAWI' }, { value: '150', label: '150 - MALAYSIA' }, { value: '151', label: '151 - MALAYSIA (LABUAN)' },
    { value: '152', label: '152 - MALDIVES' }, { value: '153', label: '153 - MALI' }, { value: '154', label: '154 - MALTA' },
    { value: '155', label: '155 - MARSHALLISLANDS' }, { value: '156', label: '156 - MARTINIQUE' }, { value: '157', label: '157 - MAURITANIA' },
    { value: '158', label: '158 - MAURITIUS' }, { value: '159', label: '159 - MAYOTTE' }, { value: '160', label: '160 - UNITED MEXICAN STATES' },
    { value: '161', label: '161 - MICRONESIA, FEDERATED STATES OF' }, { value: '162', label: '162 - MIDWAY ISLANDS' },
    { value: '163', label: '163 - MOLDOVA' }, { value: '164', label: '164 - MONACO' }, { value: '165', label: '165 - MONGOLIA' },
    { value: '166', label: '166 - MONTENEGRO' }, { value: '167', label: '167 - MONTSERRAT' }, { value: '168', label: '168 - MOROCCO' },
    { value: '169', label: '169 - MOZAMBIQUE' }, { value: '170', label: '170 - MYANMAR (BURMA)' }, { value: '171', label: '171 - NAMIBIA' },
    { value: '172', label: '172 - NAURU' }, { value: '173', label: '173 - NAVASSA ISLAND' }, { value: '174', label: '174 - NEPAL' },
    { value: '175', label: '175 - NETHERLANDS' }, { value: '176', label: '176 - NETHERLANDS ANTILLES' }, { value: '177', label: '177 - NEW CALEDONIA' },
    { value: '178', label: '178 - NEWZEALAND' }, { value: '179', label: '179 - NICARAGUA' }, { value: '180', label: '180 - NIGER' },
    { value: '181', label: '181 - NIGERIA' }, { value: '182', label: '182 - NIUE' }, { value: '183', label: '183 - NORFOLK ISLAND' },
    { value: '184', label: '184 - NORTHERN MARIANA ISLANDS' }, { value: '185', label: '185 - NORWAY' }, { value: '186', label: '186 - OMAN' },
    { value: '187', label: '187 - PAKISTAN' }, { value: '188', label: '188 - PALAU' }, { value: '189', label: '189 - PALMYRA ATOLL' },
    { value: '190', label: '190 - PANAMA' }, { value: '191', label: '191 - PAPUA NEW GUINEA' }, { value: '192', label: '192 - PARACEL ISLANDS' },
    { value: '193', label: '193 - PARAGUAY' }, { value: '194', label: '194 - PERU' }, { value: '195', label: '195 - PHILIPPINES' },
    { value: '196', label: '196 - PITCAIRN ISLANDS' }, { value: '197', label: '197 - PITCAIRN, HENDERSON, DUCIE, AND OENO ISLANDS' },
    { value: '198', label: '198 - POLAND' }, { value: '199', label: '199 - PORTUGAL' }, { value: '200', label: '200 - PUERTO RICO' },
    { value: '201', label: '201 - QATAR' }, { value: '202', label: '202 - REUNION' }, { value: '203', label: '203 - ROMANIA' },
    { value: '204', label: '204 - RUSSIA' }, { value: '205', label: '205 - RWANDA' }, { value: '206', label: '206 - SAINT BARTHELEMY' },
    { value: '207', label: '207 - SAINT HELENA' }, { value: '208', label: '208 - SAINT KITTS AND NEVIS' }, { value: '209', label: '209 - SAINT LUCIA' },
    { value: '210', label: '210 - SAINT MARTIN' }, { value: '211', label: '211 - SAINT PIERRE AND MIQUELON' },
    { value: '212', label: '212 - SAINT VINCENT AND THE GRENADINES' }, { value: '213', label: '213 - SAMOA' }, { value: '214', label: '214 - SANMARINO' },
    { value: '215', label: '215 - SAO TOME AND PRINCIPE' }, { value: '216', label: '216 - SAUDI ARABIA' }, { value: '217', label: '217 - SENEGAL' },
    { value: '218', label: '218 - SERBIA' }, { value: '219', label: '219 - SEYCHELLES' }, { value: '220', label: '220 - SIERRA LEONE' },
    { value: '221', label: '221 - SINGAPORE' }, { value: '222', label: '222 - SLOVAKIA' }, { value: '223', label: '223 - SLOVENIA' },
    { value: '224', label: '224 - SOLOMON ISLANDS' }, { value: '225', label: '225 - SOMALIA' }, { value: '226', label: '226 - SOUTH AFRICA' },
    { value: '227', label: '227 - SOUTH GEORGIA AND SOUTH SANDWICH ISLANDS' }, { value: '228', label: '228 - SPRATLY ISLANDS' },
    { value: '229', label: '229 - SPAIN' }, { value: '230', label: '230 - SRI LANKA' }, { value: '231', label: '231 - ST. VINCENT & GRENADINES' },
    { value: '232', label: '232 - SUDAN' }, { value: '233', label: '233 - SURINAME' }, { value: '234', label: '234 - SVALBARD' },
    { value: '235', label: '235 - SWAZILAND' }, { value: '236', label: '236 - SWEDEN' }, { value: '237', label: '237 - SWITZERLAND' },
    { value: '238', label: '238 - SYRIA' }, { value: '239', label: '239 - TAIWAN' }, { value: '240', label: '240 - TAJIKISTAN' },
    { value: '241', label: '241 - TANZANIA' }, { value: '242', label: '242 - TERRITORIAL COLLECTIVITY OF ST. PIERRE & MIQUELON' },
    { value: '243', label: '243 - TERRITORY OF AMERICAN SAMOA' }, { value: '244', label: '244 - TERRITORY OF ASHMORE AND CARTIER ISLANDS' },
    { value: '245', label: '245 - TERRITORY OF CHRISTMAS ISLAND' }, { value: '246', label: '246 - TERRITORY OF COCOS (KEELING) ISLANDS' },
    { value: '247', label: '247 - TERRITORY OF GUAM' }, { value: '248', label: '248 - TERRITORY OF HEARD ISLAND & MCDONALD ISLANDS' },
    { value: '249', label: '249 - TERRITORY OF NORFOLK ISLAND' }, { value: '250', label: '250 - THAILAND' }, { value: '251', label: '251 - THE BAHAMAS' },
    { value: '252', label: '252 - THE GAMBIA' }, { value: '253', label: '253 - TOGO' }, { value: '254', label: '254 - TOKELAU' },
    { value: '255', label: '255 - TONGA' }, { value: '256', label: '256 - TRINIDAD AND TOBAGO' }, { value: '257', label: '257 - TUNISIA' },
    { value: '258', label: '258 - TURKEY' }, { value: '259', label: '259 - TURKMENISTAN' }, { value: '260', label: '260 - TURKS AND CAICOS ISLANDS' },
    { value: '261', label: '261 - TUVALU' }, { value: '262', label: '262 - UGANDA' }, { value: '263', label: '263 - UKRAINE' },
    { value: '264', label: '264 - UNITED ARAB EMIRATES' }, { value: '265', label: '265 - UNITED KINGDOM' },
    { value: '266', label: '266 - UNITED STATES VIRGIN ISLANDS' }, { value: '267', label: '267 - UNITED STATES OF AMERICA' },
    { value: '268', label: '268 - URUGUAY' }, { value: '269', label: '269 - UZBEKISTAN' }, { value: '270', label: '270 - VANUATU' },
    { value: '271', label: '271 - VATICAN CITY (HOLYSEE)' }, { value: '272', label: '272 - VENEZUELA' }, { value: '273', label: '273 - VIETNAM' },
    { value: '274', label: '274 - VIRGIN ISLANDS, BRITISH' }, { value: '275', label: '275 - VIRGIN ISLANDS, U.S.' },
    { value: '276', label: '276 - WAKE ISLAND' }, { value: '277', label: '277 - WALLIS AND FUTUNA' }, { value: '278', label: '278 - WESTERN SAHARA' },
    { value: '279', label: '279 - YEMEN' }, { value: '280', label: '280 - ZAMBIA' }, { value: '281', label: '281 - ZIMBABWE' },
    { value: '282', label: '282 - COMBODIA' }, { value: '283', label: '283 - CONGO' }, { value: '284', label: '284 - IVORY COAST' },
    { value: '285', label: '285 - WEST INDIES' }, { value: '286', label: '286 - BRITISH VIRGIN ISLANDS' }
];
